import React, { useEffect, useRef } from 'react';
import { useT } from 'talkr';
import s from './index.module.scss';
import classNames from 'classnames';
import steps from '../../../survey/steps';
import tapFinger from './img/tapFinger.png';

function XmasStartScreen() {
	const { T } = useT();
	const box = useRef();
	const titleMain = useRef();
	const titleGift = useRef();
	const button = useRef();

	useEffect(() => {
		steps.setStepStatus({
			stepName: 'xmas_start_screen',
			stepStatus: true
		});
	}, []);

	function goForward() {
		steps.navigate.forward({
			preventAction: 500
		});
	}

	function flipBox() {
		box.current.style.transform = 'rotateY(180deg)';
		titleMain.current.style.display = 'none';
		titleGift.current.style.display = 'block';
		button.current.classList.add(s.button_pulse);
	}

	return (
		<div className={s.xmasStartScreen_wrapper}>
			<div className={classNames(s.xmasStartScreen_title, s.titleMain)} ref={titleMain}>
				We prepared something special to get you in the holiday spirit!
			</div>
			<div className={classNames(s.xmasStartScreen_title, s.titleGift)} ref={titleGift}>
				Start the countdown to Christmas with our <br/><span >advent challenge!</span>
			</div>
			<div className={s.xmasStartScreen_tapBox_container}>
				<div className={s.xmasStartScreen_tapBox_leftSlide}></div>
				<div className={s.flipContainer} onClick={flipBox}>
					<div className={classNames(s.flipper)} ref={box}>
						<div className={s.front}>
							<div className={s.xmasStartScreen_tapBox}>
								<img className={s.xmasStartScreen_tapBox_img} src={tapFinger} alt='tap' />
								<div className={s.xmasStartScreen_tapBox_textTap}>Tap to open</div>
								<div className={s.xmasStartScreen_tapBox_textTap_description}>New day = new fitness surprise</div>
							</div>
						</div>
						<div className={s.back}>
							<div className={s.xmasStartScreen_giftBox}>
								<div className={s.xmasStartScreen_giftBox_day}>day 1</div>
								<div className={s.xmasStartScreen_giftBox_bottom}>
									<div className={s.xmasStartScreen_giftBox_title}>Fitness Advent Challenge</div>
									<div className={s.xmasStartScreen_giftBox_description}>Healthy workouts and tips</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className={s.xmasStartScreen_tapBox_rightSlide}></div>
			</div>
			<div className={s.xmasStartScreen_button}>
				<button 
					onClick={goForward}
					className={s.button}
					ref={button}
					type="button">{T('xmasStartScreen_button')}</button>
			</div>
		</div>
	);
}

export default XmasStartScreen;
